import { getCardStyle } from './cardStyle';

const loadedUrls = new Set();

export function preloadImage(url) {
  if (!url || loadedUrls.has(url)) return Promise.resolve();
  return new Promise((resolve) => {
    const img = new Image();
    const done = () => {
      loadedUrls.add(url);
      resolve();
    };
    img.onload = done;
    img.onerror = done;
    img.src = url;
  });
}

export function preloadCardImages(cards) {
  const urls = new Set();
  for (const card of cards) {
    const style = getCardStyle(card, { context: 'list' });
    if (style.iconUrl) urls.add(style.iconUrl);
    if (style.hasPhoto && style.imageUrl) urls.add(style.imageUrl);
  }
  return Promise.all([...urls].map(preloadImage));
}
